import type { CreateAchieveType, CreateLedgerType, CreateUserType, ReqHeaderType, ResCreateUserType } from '@/types';
import type { CustomAxiosResponse } from '../AxiosResponse';
import { axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

export const createUser = async (createUserType: CreateUserType): Promise<CustomAxiosResponse<ResCreateUserType>> => {
  const payload = {
    path: '/v1/point-users',
    body: { ...createUserType },
  };
  return sendRequest(payload, 'createUser', axiosPost);
};

export const createLedger = async (createLedgerType: CreateLedgerType, reqHeaderType: ReqHeaderType) => {
  const payload = {
    path: '/v1/point-user-ledger',
    body: { ...createLedgerType },
    addHeaders: { ...reqHeaderType },
  };
  return sendRequest(payload, 'createLedger', axiosPost);
};

export const createAchieve = async (createAchieveType: CreateAchieveType, reqHeaderType: ReqHeaderType) => {
  const payload = {
    path: '/v1/point-achieve',
    body: { ...createAchieveType },
    addHeaders: { ...reqHeaderType },
  };
  return sendRequest(payload, 'createAchieve', axiosPost);
};
